module.exports = __webpack_public_path__ + "static/media/loginback.9bc7364d.jpg";